import React from 'react';
import Layout from '../components/Layout';

function SpareDashboard({ user, onLogout }) {
  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Spare Management Dashboard</h1>
          <p className="text-gray-600 mt-2">Metrics on spare parts value, quantity, and consumption</p>
        </div>

        {/* Key Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
          <div className="bg-white rounded-lg shadow p-4">
            <p className="text-sm text-gray-600">Total Spare Value</p>
            <p className="text-3xl font-bold text-blue-600">₹0</p>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <p className="text-sm text-gray-600">Total Parts</p>
            <p className="text-3xl font-bold text-green-600">0</p>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <p className="text-sm text-gray-600">Avg Cost/Repair</p>
            <p className="text-3xl font-bold text-purple-600">₹0</p>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <p className="text-sm text-gray-600">Low Stock Items</p>
            <p className="text-3xl font-bold text-red-600">0</p>
          </div>
        </div>

        {/* Charts Placeholder */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-lg font-semibold mb-4">Consumption by Category</h2>
            <div className="h-64 flex items-center justify-center text-gray-500">
              Chart will be displayed here
            </div>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-lg font-semibold mb-4">Top Consumed Parts</h2>
            <div className="h-64 flex items-center justify-center text-gray-500">
              Chart will be displayed here
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default SpareDashboard;
